import { Divider, Grid, ClickAwayListener, Modal, Box, Stack, Typography } from "@mui/material";
import MedicationOutlinedIcon from '@mui/icons-material/MedicationOutlined';
import {
    FEATURE_TYPE, hasMedicalEducation } from '../utils/features';

import _ from "lodash";


const Features = ({
  features, sxExtra
}) => {

  return (
      <Stack data-test-id={"features-section"} sx={{...sxExtra}}>
          {
              _.some(features, hasMedicalEducation) &&
              <Grid container>
                  <Grid item xs={2} sx={{justifyContent: 'center', alignItems: 'center', display:" flex"}}>
                      <MedicationOutlinedIcon
                          fontSize={"large"}

                          sx={{color: "grey.500"}}
                      />
                  </Grid>
                  <Grid item xs={10}>
                      <Stack>
                          <Typography variant={"body2"}>Медицинское образование</Typography>
                          <Typography variant={"body2"} color={'grey.400'} >У всех специалистов есть медицинское образование </Typography>
                      </Stack>
                  </Grid>
              </Grid>
          }
      </Stack>

  );
};

export default Features;
